function sizeGuideShow() {
    document.querySelectorAll('.product .product__accordion');
    if(document.querySelectorAll('.product .product__accordion')) {
        let product__accordion = document.querySelectorAll('.product .product__accordion')[0];
        product__accordion.querySelector('details').setAttribute('open','');
    }
}

sizeGuideShow();
showNoticationBtn(false);
  /*处理size、color信息 */
  //变体产品数据
  let product_arrM = [];
  //变体size集合
  let product_sizeArrM = [];
  //变体color集合
  let product_colorArrM = [];
  //每个product几种颜色 暂时用不到
  let product_colorLenghArrM = [];
  //变体variants集合
  let product_variantsArrM = [];
  let product_allID=$("input[name='product-id']").val();
  getAllProducts();
  showProductMedia($("input[name='product-id']").val());


  function getAllProducts() {
    /**string */
    let jsonStr = document.getElementById('product_related').innerHTML;

    // jsonStr = jsonStr.replace(/</g,'&lt;');
    jsonStr = jsonStr.replace(/=\".*?\"/g, '');
    var products = JSON.parse(jsonStr);
   
    if(!products) return;    
    
    products.forEach((product, index) => {     
      if(product.id==product_allID){
        
        var variants = product.variants;       

        //获取当前产品的PID，匹配HTML里已有对应PID的尺寸的variant ID 和库存
        let quantityV = '';
        $('.product_va').each(function(){
        let quantityID=$(this).attr("data-pid");        
          if(quantityID == product.id) {
            quantityV = $(this).html();
          }
        })
        //处理不同变种的数量赋值
        variants.forEach((variant, indexJ) => {
        let content = $(quantityV)[indexJ].innerHTML;
        let id = content.split("-")[0];
        //获取当前变体类别的数量
        let inventory_quantity = content.split("-")[1];
        if (id == variant.id) {
          variant.inventory_quantity = inventory_quantity;
        //variant.available
        } else {
        variant.inventory_quantity = 0;
        }
        }); 

      
   //单个产品id及信息结束
    }
    //获取所有size、color信息
    product.options.forEach((option) => {
       //改成只获取当前pid下的不同尺寸的信息
     if ((option.toLowerCase() == 'size' || option.toLowerCase() == 'サイズ') && product.id == product_allID) {
          let values = [];
          product.variants.forEach(sizeItem=>{
              let param = {
                  id:sizeItem.id,
                  size: sizeItem.option2,
                  quantity: sizeItem.inventory_quantity,
                  available:sizeItem.available
              }
              values.push(param);
          })
          //存放所有所有变体size
          product_sizeArrM.push(values);
      }
      if (option.toLowerCase() == 'color' || option.toLowerCase() == '色') {
          //存放所有变体color
          product_colorArrM.push({
              id: product.id,
              handle:product.handle,
              color: product.variants[0].option1,
              title: product.title
          });
          product_colorLenghArrM.push(1);
      }
    })
   //存放所有变体数组
    product_variantsArrM.push(variants);
    //let quantityV = document.getElementsByClassName('product_va')[index];
    //console.log(quantityV);
  });
    product_arrM = products;
 }


  //自定义color对象实例

  class ProductSize {
    constructor() {
    this.currentSize = '';
		this.sizeIndex = undefined;

        this.list = $(".product-size-item");
        this.list.each((index,element) => {
          document.addEventListener('DOMContentLoaded', () => {
                $(element).bind('click',function(){
				$('.product-size-item').each((index2,element2)=>{
					if(index2 == index) {
            //  console.log(element2.dataset.id);
            //  console.log(element2.dataset.value)
             //BIS_trigger_function();
						$(element2).addClass('product-size-item-active');
					}else {
						$(element2).removeClass('product-size-item-active');
					}
				})
                //更新产品变种id
                updateProductVariantId();
			})
              })
        })
    }
    //当color内容修改时更新size内容
    changeSizeSelectContent(value,isShowSize) {
		//获取size数组的数据
    
		let sizeList = product_sizeArrM[value];
		// console.log([value]);
		// var newSizeList = [];
	
		// sizeList.forEach(function(item){
		// 	// let sizeValue = getSizeByTypeSize(currentSizeType,item.size.toString());

        //     console.log('item===',item);
		// 	// newSizeList.push({size: sizeValue, quantity: item.quantity});	
		// }) 

		//初始化size内容
		let sizeHtml = '';
    //console.log('item===',item);
		//循环添加li标签 用于自定义下拉填充
        sizeList.forEach((item,index)=>{           
            //sizeHtml += "<div class='product-size-item'" + "data-index=" + index + " " +  (item.quantity==0?" style='color:#999;text-decoration:line-through;'":"") + " data-quantity='" + item.quantity + "'" + " data-value='" + item.size + "'>" + item.size + "</div>";
             sizeHtml += "<div class='product-size-item'" +"data-id="+item.id + " " +"data-index=" + index + " " +  (item.available==false?" style='color:#999;text-decoration:line-through;'":"") + " data-quantity='" + item.quantity + "'" + " data-value='" + item.size + "'>" + item.size + "</div>";
        })
			//下拉内容渲染
		$('.product-size-list').html(sizeHtml);
		if(isShowSize) {
       console.log()
			// let sizeIndex = this.sizeIndex;
			// this.setListener();
			// this.sizeIndex = sizeIndex;
			// if(sizeIndex < this.list.children.length) {
			// 	this.list.style.display = "block";
			// 	this.list.children[sizeIndex].click(); 
			// }
		}else {
			// this.setListener();
		}

        this.list = $(".product-size-item");
        this.list.each((index,element) => {
            $(element).bind('click',function(){
				$('.product-size-item').each((index2,element2)=>{
					if(index2 == index) {
            console.log(element2.dataset.value);
            console.log(element2.dataset.id);
            
						$(element2).addClass('product-size-item-active');
					}else {
						$(element2).removeClass('product-size-item-active');
					}
				})
                //更新产品变种id
                updateProductVariantId();
			})
        })
		
	}
    
  }

  class ProductColor {
    constructor() {
        //当前色值
        this.currentColor =  document.querySelector("#currentColor");
        //当前颜色名称
		this.currenColorName = document.querySelector("#currentColorName");
        //所有颜色标签集合
		this.list = $(".product-color-item");

        this.list.each((index,element) => {
            const currentColor = this.currentColor;
            const currenColorName = this.currenColorName;
            let colorName  = element.dataset.value;
            let productTitle = element.dataset.title;
            let productId=element.dataset.id;
            let productHandle=element.dataset.handle;

            let colorInfo = getColorByName(colorName,productTitle);
            // let sRGB = colorInfo.background;
            let background = colorInfo.background;
            let backgroundImage = colorInfo.backgroundImage;
            //每个标签设置颜色          
            element.querySelector('span').style.background = background;
            //设置图片后就显示背景图片
            if (backgroundImage) {
              element.querySelector('span').style.backgroundImage = `url(${backgroundImage})`;//设置图片背景
              element.querySelector('span').style.backgroundSize = 'cover';      // 图片覆盖整个元素
              element.querySelector('span').style.backgroundRepeat = 'no-repeat'; // 不平铺
              element.querySelector('span').style.backgroundPosition = 'center';  // 居中显示
            }
            //默认选中第一个颜色
            if(productId == product_allID) {
                currentColor.style.background = background;
                currentColor.dataset.value = index;
                currenColorName.innerHTML = colorName;

                $(element).addClass('product-color-item-active');
                $(element).removeClass('product-color-item-no-active');
            }
            //为每个item绑定点击事件
			$(element).bind('click',function(){
				$('.product-color-item').each((index2,element2)=>{
					if(index2 == index) {                   
						$(element2).addClass('product-color-item-active');
						$(element2).removeClass('product-color-item-no-active');
					}else {
						$(element2).removeClass('product-color-item-active');
						$(element2).addClass('product-color-item-no-active');
					}
				})
                const currentUrl = window.location.href;
                const match = currentUrl.match(/https?:\/\/[^/]+\/([^/]+)\/products\//);
                let newUrl;
                if (match) {
                  const langDir = match[1];
                  newUrl = `/${langDir}/products/${productHandle}`;
              } else {
                  newUrl = `/products/${productHandle}`;
              }
              window.location.href = newUrl;
				//当颜色改变时修改size渲染内容
			 	//productSize.changeSizeSelectContent(index,false);
				// changeColor(0,sRGB);
                //$("input[name='product-id']").val(productId);                
                // console.log(productId);       
				//currentColor.style.background = background;
				//currentColor.dataset.value = index;
				//currentColorName.innerHTML = colorName;
				showNoticationBtn(false);

                //展示不同media
        //showProductMedia(index);
			})

        })
    }

  }

  //自定义size对象实例

var productSize = '';
var productColor = ''; 

//初始化color size 内容
function initColorSize() {
	let value = 0;
	//获取size数组的第一组数据
	let sizeList = product_sizeArrM[value];
	//初始化size内容
	let sizeHtml = '';
	//循环添加li标签 用于自定义下拉填充
  console.log(product_sizeArrM);
	sizeList.forEach((item,index)=>{
    
		//sizeHtml += "<div class='product-size-item'" + "data-index=" + index + " " +  (item.quantity==0?" style='color:#999;text-decoration:line-through;'":"") + " data-quantity='" + item.quantity + "'" + " data-value='" + item.size + "'>" + item.size + "</div>";
    sizeHtml += "<div class='product-size-item'" +"data-id="+item.id + " "+ "data-index=" + index + " " +  (item.available==false?" style='color:#999;text-decoration:line-through;'":"") + " data-quantity='" + item.quantity + "'" + " data-value='" + item.size + "'>" + item.size + "</div>";
	})
	//下拉内容渲染
	$('.product-size-list').html(sizeHtml);
  //console.log(sizeHtml);
	//默认取第一项数据
    productSize = new ProductSize();
	//重新给予下拉内容点击事件
	// customSelect.setListener();
	//获取color数组数据
	let colorList = product_colorArrM;
  
	let colorHtml = '';
	colorList.forEach((item,index)=>{
		colorHtml += "<div class='product-color-item product-color-item-no-active' data-id='"+item.id+"' "+"data-handle="+item.handle + " " + "data-value='" + item.color + "' " + "data-title='" + item.title + "'" + "data-index=" + index + "><span></span></div>";
	});
	$('.product-color-list').html(colorHtml);

	productColor = new ProductColor();
}
initColorSize();

function showProductMedia(index) {
  
    // $('.product-media-left').each((indexJ,element) => {
    //     if(indexJ == index) {
    //         element.style.display = 'inherit';
    //     }else {
    //         element.style.display = 'none';
    //     }
    // })

    // let productMediaPc = $(".product-media-left");
    
    // if (productMediaPc && productMediaPc.length) {

    //   for (var i=0; i<productMediaPc.length; i++){
    //    var indexJ= productMediaPc[i].dataset.pid;
    //    var newid=$("media-gallery")[i].closest('.product-media-left');
    //    console.log(newid);
    //     if(indexJ==index){
          
    //      // console.log(newid.html)       
    //     }else{
    //       //newid.hide() 
    //     }
    //   }
    // }

    //let productMediaPc = document.querySelectorAll('.product-media-left');
    let productMediaPc = $('.product-media-left');
    if (productMediaPc && productMediaPc.length) {
       $('.product-media-left').each(function(indexJ,element){
          let mediaid=$(this).find("media-gallery").attr("data-pid");
          
            if(mediaid == index) {
              $(this).show();
            }else {
              $(this).hide();
            }
        })
    }


    let slideshowComponent = document.querySelector('product-media-mb').querySelectorAll('slideshow-component');
    if (slideshowComponent && slideshowComponent.length) {
        slideshowComponent.forEach((element,indexJ) => {
          mediaMbID=element.dataset.pid;
          //console.log(mediaMbID);
            if(mediaMbID == index) {
                element.style.display = 'inherit';
            }else {
                element.style.display = 'none';
            }
        })
    }

    // showProductMeidaMb(index);
}

function showProductMeidaMb(currentIndex) {
    let container = document.querySelector('product-media-mb');
    container.setAttribute('data-current-index',currentIndex);
    container.querySelectorAll('.focus').forEach((element, index) => {
        if (index == currentIndex) {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      })

      init(currentIndex,false);
      initOl(currentIndex);
  }

function splitCurrency(priceString) {
  // 更新正则表达式，支持多种货币符号（如 ¥、$）和带逗号的金额
  const match = priceString.match(/^([^\d]+)([\d,]+(?:\.\d{2})?)$/);

  // 如果匹配成功，则返回分离后的结果
  if (match) {
    const [_, currencySymbol, amount] = match;
    return {
      currencySymbol,
      amount
    };
  }

  // 如果匹配失败，返回空对象
  return {
    currencySymbol: '',
    amount: ''
  };
}
function convertCentsToShopifyMoney(cents, currencySymbol) {
  // 将分转换为元，保留两位小数
  const amountInDollars = (cents / 100).toFixed(2);

  // 使用 Intl.NumberFormat 格式化整数部分，确保千位分隔符
  const [integerPart, decimalPart] = amountInDollars.split('.');

  // 格式化整数部分
  const formattedInteger = new Intl.NumberFormat('en-US').format(integerPart);

  // 返回最终的格式化字符串
  return `${currencySymbol}${formattedInteger}.${decimalPart}`;
}
function showRegularOrCompare(variant) {
  console.log(variant.compare_at_price);
  const productList = document.querySelector("#product-size-list").getAttribute("data-price");
  const currencySymbol = splitCurrency(productList).currencySymbol;
  const regularPriceElementList = document.querySelectorAll('.price-item.price-item--regular');
  regularPriceElementList.forEach((priceElement, index) => {
    priceElement.innerHTML = convertCentsToShopifyMoney(variant.price,currencySymbol);
  })
  const TwopriceElementList = document.querySelectorAll('#money-price-show');
  const TwoComparePriceElementList = document.querySelectorAll('#compare-money-price-show');
  TwopriceElementList.forEach((priceElement, index) => {
        priceElement.innerHTML = convertCentsToShopifyMoney(variant.price,currencySymbol);
      })
      TwoComparePriceElementList.forEach((ComparePriceElement, index) => {
        ComparePriceElement.innerHTML = convertCentsToShopifyMoney(variant.compare_at_price,currencySymbol);
      })
  if(variant.compare_at_price === 0 || variant.compare_at_price === null){
        const regular_price_elementList = document.querySelectorAll('.price__container .price__regular');
        regular_price_elementList.forEach((item)=>{
          item.style.display = 'block'
        })
        const priceDomList = document.querySelectorAll('.price__container .price__regular .price-item.price-item--regular');
        priceDomList.forEach((item)=>{
          item.style.textDecoration = 'inherit';
          item.style.fontSize = 'inherit';
          item.style.color = 'inherit';
        })
        const compare_price_elementList = document.querySelectorAll('.price__container .price__sale');
        compare_price_elementList.forEach((item)=>{
          item.style.display = 'none'
        })
      }else{
        const regular_price_elementList = document.querySelectorAll('.price__container .price__regular');
        regular_price_elementList.forEach((item)=>{
          item.style.display = 'none'
        })
        const compare_price_elementList = document.querySelectorAll('.price__container .price__sale');
        compare_price_elementList.forEach((item)=>{
          item.style.display = 'block'
        })
        const comparePriceDomList = document.querySelectorAll('.price__container .price__sale .price-item.price-item--regular');
        comparePriceDomList.forEach((item)=>{
          item.style.textDecoration = 'line-through';
          item.style.fontSize = '11px';
          item.style.color = 'rgba(var(--color-foreground), 0.75)';
        })
      }
}
function updateProductVariantId() {
    if(!product_variantsArrM.length) return;
    //获取选中变种id 重新赋值
    let colorIndex = document.querySelector('.product-color-item-active').dataset.index;
    //let idIndex=document.querySelector('.product-color-item-active').dataset.id;
   
    let sizeIndex = document.querySelector('.product-size-item-active').dataset.index;
    let variant = product_variantsArrM[colorIndex][sizeIndex];
    // console.log("variant.available----"+variant.available);
    //选中时设置变体id
    document.querySelector('.product-variant-id').setAttribute('value',variant.id);
    let outterPrice = document.querySelector("#outter-price");
      showRegularOrCompare(variant);
    //通过当前变体数量 更新add btn状态
    let preorder = variant.inventory_quantity
    
    if(preorder==0 && variant.available==true){
      showNoticationBtn(true);
      updateAddButton(
        true,
        window.variantStrings.inventory_out_of_stock_continue_selling,
        true,
        false
      )
    }else if(preorder==0 && variant.available==false){
      showNoticationBtn(true);
      updateAddButton( 
                   false,
                   window.variantStrings.soldOut,
                   true,
                   true
            )
    }else{
      showNoticationBtn(false);
      updateAddButton(true,window.variantStrings.addToCart,true,true)
    }
//     let disabled = variant.available==false;
//     updateAddButton( 
//            disabled,
//            window.variantStrings.soldOut,
//            true,
//            true
//     )
// 
}
//更新btn状态
function updateAddButton(disable = true, text, modifyClass = true,outContinue=true) {
    let sectionId = document.querySelector('.product-variant').dataset.sectionId;

    const productForm = document.getElementById(`product-form-${sectionId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable==false) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = text;
      let colorIndex = document.querySelector('.product-color-item-active').dataset.index;

      console.log("colorIndex===",colorIndex)
      //获取当前选中子产品信息
      let productInfo = product_arrM[colorIndex];
      //去除title后缀
      productInfo.title = productInfo.title.split('-')[0];  
      //$('.BIS_trigger').attr('data-product-data',JSON.stringify(productInfo));
      
    }else{
      addButton.removeAttribute('disabled');
      addButtonText.textContent = text;
    }

    if (!modifyClass) return;
}


//初始化media移动端事件
function initProductMediaMb() {
    init(currentIndex);
    initOl(currentIndex);
}


//是否显示售罄通知btn
function showNoticationBtn(isShow) {
	// let btn = document.getElementsByClassName('BIS_trigger')[0];
	// if (isShow)  btn.style.display = 'flex';
	// else btn.style.display = 'none';
  //  声明定时器
var timer = null
//  检查dom是否执行完成
function check() {
    let btn = document.getElementById('BIS_trigger')
    if(btn) {
         //  执行dom加载完成后的操作
         //$('#BIS_trigger').remove();         
         if (isShow) {
           btn.style.display = 'none'; 
          $('#notify_button').show()
        }else{
          btn.style.display = 'none';
          $('#notify_button').hide();
         }
        
        //  清除定时器
        if(!timer) {
            clearTimeout(timer)
        }
    } else {
        //  自我调用           
        timer = setTimeout(check, 0)
    }
}
//  首次执行
check()
}



  $('#notify_button').click(function(e) {
    console.log("here");
    productID=$("input[name='product-id']").val();
    variantID=$(".product-variant-id").val();
    console.log("product-id:"+productID);
    console.log("varianID:"+variantID);
    //BIS.create(email, varianID, productID); // create the notification
    BIS.popup.show({variantId:variantID});

  })



  //BIS.popup.show({productId:productID, variantId: varianID});
